import { useEffect, useState } from "react";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const faqListEndpoint = ApiEndpoints.faq.faqList;
const faqDeleteEndpoint = ApiEndpoints.faq.faqDelete;
const faqEditPath = "edit-faq";
const tableHeader = ["Url", "Questions", "Status"];
const tbody = ["url", "faq_count", "status"];

export default function FaqListing() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", faqListEndpoint);
      const result = response.faqs || [];
      setData(result.map((item) => ({
        ...item,
        faq_count: item.faqs?.length || 0,
      })));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (faq_id) => {
    const payload = { faq_id };
    try {
      const response = await ApiRequest("POST", faqDeleteEndpoint, payload);
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.log(error);
    }
  };

  const pagename = {
    name: "FAQ Management",
    user: "Admin",
    innerpage: "FAQ Management"
  };

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-faq">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={faqEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
